import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollableArea from '../../components/scrollableArea';

const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    p: 2.5,
};

const PUBLISHER_ROW_HEIGHT = 149;
const PUBLISHER_ROW_GAP = 12;
const MAX_VISIBLE_ROWS = 4;
const GRID_MAX_HEIGHT = `${MAX_VISIBLE_ROWS * PUBLISHER_ROW_HEIGHT + (MAX_VISIBLE_ROWS - 1) * PUBLISHER_ROW_GAP}px`;

const publisherGrid = {
    display: 'grid',
    gridTemplateColumns: { xs: 'repeat(2, 125px)', sm: 'repeat(3, 125px)', md: 'repeat(5, 125px)' },
    justifyContent: 'space-between',
    rowGap: `${PUBLISHER_ROW_GAP}px`,
};

const publisherItem = {
    display: 'block',
    width: '100%',
    height: `${PUBLISHER_ROW_HEIGHT}px`,
    p: 0,
    border: 'none',
    background: 'none',
    color: 'inherit',
    font: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
    borderRadius: '12px',
    '&:hover > span:first-of-type, &:focus-visible > span:first-of-type': {
        borderColor: 'rgba(0,215,255,0.6)',
    },
    '&:focus-visible': {
        outline: '2px solid rgba(0,215,255,0.8)',
        outlineOffset: '2px',
    },
};

const coverBox = {
    width: '125px',
    height: '125px',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.10)',
    transition: 'border-color 0.18s ease',
    background: 'rgba(255,255,255,0.04)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { borderColor: 'rgba(0,215,255,0.6)' },
};

function Collections({ publishers = [], onSelectPublisher }) {
    function renderEmpty() {
        return (
            <Typography sx={{ fontSize: '0.875rem', color: 'var(--ecal-lightgrey)', mt: 1 }}>
                No brands yet — start syncing to build your collection.
            </Typography>
        );
    }

    function renderPublishers() {
        return (
            <ScrollableArea maxHeight={GRID_MAX_HEIGHT} sx={{ mt: 2, px: 1.5 }}>
                <Box sx={publisherGrid}>
                    {publishers.map((p) => (
                        <Box
                            key={p.id || p.pubId}
                            component="button"
                            type="button"
                            onClick={() => onSelectPublisher(p.id)}
                            aria-label={`Manage ${p.name}`}
                            sx={publisherItem}
                        >
                            <Box component="span" sx={{ ...coverBox, background: p.logoColors?.length >= 2
                                ? `linear-gradient(135deg, ${p.logoColors[0]}, ${p.logoColors[1]})`
                                : 'rgba(255,255,255,0.04)'
                            }}>
                                {p.logo
                                    ? <Box component="img" src={p.logo} alt={p.name} sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px' }} />
                                    : <Typography component="span" sx={{ fontSize: '1.5rem', fontWeight: 700, color: '#fff' }}>{p.name?.[0]}</Typography>
                                }
                            </Box>
                            <Typography component="span" sx={{ display: 'block', fontSize: '12px', lineHeight: '18px', color: 'var(--ecal-white)', mt: 0.75, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {p.name}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </ScrollableArea>
        );
    }

    return (
        <Box sx={card}>
            <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '2.16px', color: 'var(--ecal-lightblue)' }}>
                My collection
            </Typography>
            {publishers.length === 0 ? renderEmpty() : renderPublishers()}
        </Box>
    );
}

export default Collections;
